import { render } from "./DegreeTypeFilter.vue?vue&type=template&id=48dd98ca&ts=true"
import script from "./DegreeTypeFilter.ts?vue&type=script&lang=ts&external"
export * from "./DegreeTypeFilter.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__